import type { WeeklyStatusItemProps } from '@services/api/previewManagement/types'

/**
 * Padrão operacional da Gestão da Prévia: os cards de status exibem no máximo 5 semanas.
 * O backend pode retornar 6 semanas na competência — as excedentes são ignoradas apenas
 * na exibição, sem qualquer efeito sobre status, cálculos ou fluxo de aprovação.
 */
export const MAX_VISIBLE_WEEKS = 5

export const getVisibleWeeks = (weeks?: WeeklyStatusItemProps[]): WeeklyStatusItemProps[] =>
  weeks?.slice(0, MAX_VISIBLE_WEEKS) || []
